import { Component, computed, input, output } from '@angular/core';
import { Role, Vehicle } from '@agilox/common';
import { SelectOption } from '@agilox/ui-common';
import { VehicleSelectUnionCheckboxPipe } from './pipes/vehicle-select-union-checkbox.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { EmptyPipe } from '@agilox/pipe/empty';
import { CheckboxComponent, IconModule } from '@agilox/ui';

@Component({
	selector: 'union-select-option',
	templateUrl: './union-select-option.component.html',
	imports: [
		CheckboxComponent,
		VehicleSelectUnionCheckboxPipe,
		NgTemplateOutlet,
		IconModule,
		EmptyPipe,
	],
})
export class UnionSelectOptionComponent {
	union = input<string>('');

	options = input<SelectOption<Vehicle>[] | null>(null);

	selectedVehicles = input<Vehicle[]>([]);

	toggleable = input<boolean>(false);

	collapsed = input<boolean>(false);

	role = input<Role>(Role.support);

	deselectAll = output<void>();

	selectAll = output<void>();

	toggled = output<void>();

	isInternalUser = computed(() => {
		// special case => partner is treated as an internal user
		return this.role() !== Role.customer;
	});

	customerName = computed(() => {
		// Get customer name from the first vehicle in the union
		const firstVehicle = this.options()?.[0]?.value;
		return firstVehicle?.customer || '';
	});
	public handleClick() {
		if (this.allPossibleOptionsSelected()) {
			this.deselectAll.emit();
		} else {
			this.selectAll.emit();
		}
	}

	private allPossibleOptionsSelected() {
		const selectedSerials = new Set(this.selectedVehicles().map((vehicle) => vehicle.serial));
		return (this.options() ?? [])
			.filter((option) => option.value?.union === this.union())
			.every((option) => selectedSerials.has(option.value!.serial));
	}

	public handleCheckboxClick(event: MouseEvent) {
		event.stopPropagation();
		event.preventDefault();
		this.handleClick();
	}

	public onToggle() {
		this.toggled.emit();
	}
}
